// mytamilkart.com (landing page and /plan): REACT_APP_SITE_URL if set; on the
// local dev server (npm start) the local site, so "Change plan" and the logo
// never reach the live site while developing; otherwise (builds, tests) the live site
export const SITE_URL = process.env.REACT_APP_SITE_URL
    || (process.env.NODE_ENV === 'development' ? 'http://localhost:3001' : 'https://mytamilkart.com');
